import React from "react";
import "./aboutUs.style.sass";
import { Alert, Icon } from "rsuite";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import headerImg from "../../assets/image/aboutUsHeader.png";
// import employeData from '../../data/aboutUs/aboutUs';
import Axios from "axios";
import { css } from "@emotion/react";
import GridLoader from "react-spinners/GridLoader";
import BarLoader from "react-spinners/BarLoader";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectAboutUs } from "../../redux/site/site.selector";
import { SetAboutUs } from "../../redux/site/site.actions";
import { Setting } from "../../setting";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class AboutUsLayout extends React.Component {
  componentDidMount() {
    const { setAboutUs } = this.props;
    Axios.get(`${Setting.apiUrl}api/aboutUs/list`)
      .then(res => {
        console.log(res);
        setAboutUs(res.data);
        document.getElementById("aboutUsInfo").innerHTML = res.data.description;
      })
      .catch(error => {
        Alert.error(`${error}`);
      });
  }

  render() {
    const { getAboutUs } = this.props;

    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
    `;
    const settings = {
      dots: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      rtl: true,
    };
    return (
      <div>
        <SubHeaderComponent pageName="درباره ما" imageSrc={headerImg} />
        <div className="aboutUs-content">
          <Slider {...settings}>
            {getAboutUs ? (
              getAboutUs.employees[0].gallery.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="about-us-slider-itm"
                    style={{ display: "flex" }}
                  >
                    <img src={`${Setting.apiUrl}/${item.path}`} alt="" />
                  </div>
                );
              })
            ) : (
              <GridLoader
                color="#FF8F3C"
                loading={true}
                css={override}
                size={20}
                margin={7}
              />
            )}
          </Slider>
        </div>
        <div className="about-us" style={{ marginTop: "50px" }}>
          <div className="about-us-description">
            <div className="about-us-ul">
              <ul>
                <li>
                  <span>ما را بیشتر بشناسید</span>
                </li>
              </ul>
            </div>
            {getAboutUs ? null : (
              <BarLoader
                color="#FF8F3C"
                loading={true}
                css={override}
                hight={4}
                width={300}
              />
            )}
            <div className="about-us-description-p" id="aboutUsInfo" />
          </div>
          {/* <div className="about-us-content">
            <div className="about-us-ul">
              <ul className="about-us-ul-2">
                <li>
                  <span>همکاران ارشد زیتونیکس</span>
                </li>
              </ul>
            </div>
            <div className="about-us-grid-area">
              {getAboutUs ? (
                getAboutUs.employees.map((item, i) => {
                  return (
                    <div key={i} className="grid-box">
                      <img
                        className="about-us-employe-img"
                        src={`${Setting.apiUrl}${item.img}`}
                        alt="xitonix employe"
                      />
                      <br />
                      <span>
                        <Icon
                          className="employe-icon"
                          icon="dot-circle-o"
                          style={{ opacity: "0.6" }}
                        />{" "}
                        <strong>{item.name}</strong>
                      </span>
                      <br />
                      <span style={{ position: "relative", right: "15px" }}>
                        {item.position}
                      </span>
                    </div>
                  );
                })
              ) : (
                <GridLoader
                  color="#FF8F3C"
                  loading={true}
                  css={override}
                  size={20}
                  margin={7}
                />
              )}
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  getAboutUs: selectAboutUs,
});
const mapDispatchToProps = dispatch => ({
  setAboutUs: data => dispatch(SetAboutUs(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AboutUsLayout);
